export const ENUM_COLORS = {
  LIGHTEST: 'LIGHTEST',
  IP_BLACK_1: 'IP_BLACK_1',
  IP_BLACK_4: 'IP_BLACK_4',
  IP_BLACK_5: 'IP_BLACK_5',
  ERROR: 'ERROR'
};

export const ENUM_FONTS = {
  H1: 'H1',
  H1_INTER: 'H1_INTER',
  TEXT_MIDDLE_NORMAL: 'TEXT_MIDDLE_NORMAL',
  TEXT_SMALL: 'TEXT_SMALL',
  TEXT_SMALL_HEIGHT_24: 'TEXT_SMALL_HEIGHT_24',
  TEXT_SMALL_HEIGHT_16: 'TEXT_SMALL_HEIGHT_16'
};
